import {
    DeactivateActionTypes,
    DeactivateStart,
    DeactivateSuccess,
    DeactivateFailure,
    DeactivateStartPayload,
    DeactivateSuccessPayload,
    DeactivateFailurePayload,
} from "./deactivate.types";

export const deactivateStart = (
    payload: DeactivateStartPayload
): DeactivateStart => ({
    type: DeactivateActionTypes.DEACTIVATE_START,
    payload,
});

export const deactivateSuccess = (
    payload: DeactivateSuccessPayload
): DeactivateSuccess => ({
    type: DeactivateActionTypes.DEACTIVATE_SUCCESS,
    payload,
});

export const deactivateFailure = (
    payload: DeactivateFailurePayload
): DeactivateFailure => ({
    type: DeactivateActionTypes.DEACTIVATE_FAILURE,
    payload,
});
